import { injectable } from 'inversify';
import { createSelector } from '@reduxjs/toolkit';
import {
  IncidentRepository,
  PlayerRepository,
} from '../state/reduxRepositories';
import { Incident } from '../state/reduxRepositories/incident/incident.interface';
import { Player } from '../state/reduxRepositories/players/player.interfaces';
import { PlayerIncidentList } from '../pages/incidentsList/incidentsList.interface';

@injectable()
export class IncidentDomain {
  openIncidentSelector: any;
  closedIncidentSelector: any;
  incidentSelector: any;

  public constructor(
    private incidentRepository: IncidentRepository,
    private playerRepository: PlayerRepository,
  ) {
    this.createIncidentSelector();
    this.createOpenIncidentSelector();
    this.createClosedIncidentSelector();
  }

  createIncidentSelector = () => {
    this.incidentSelector = createSelector(
      this.playerRepository.selectors.resourcesSelector,
      this.incidentRepository.selectors.resourcesSelector,
      (players: Player[], incidents: Incident[]) => {
        return incidents.map((incident: Incident) => {
          const findPlayer = players.find(
            (player: Player) => player.id === incident.playerId,
          );
          return {
            id: incident.id,
            playerId: incident.playerId,
            incidentDateTime: incident.incidentDateTime,
            playerName: `${findPlayer?.firstName} ${findPlayer?.lastName}`,
            updatedAt: incident.updatedAt,
            redFlags: incident.report?.redFlags,
            createdAt: incident.createdAt,
            activity: incident.report?.activity,
            activityOther: incident.report.activityOther,
            sessionType: incident.report?.sessionType,
            sessionTypeOther: incident.report?.sessionTypeOther,
            playType: incident.report?.playType,
            playTypeOther: incident.report?.playTypeOther,
            headImpactType: incident.report?.headImpactType,
            headImpactTypeOther: incident.report?.headImpactTypeOther,
            open:
              !findPlayer?.clearedToPlay &&
              new Date(incident.incidentDateTime).getTime() >=
                new Date(
                  findPlayer?.notClearedToPlayUpdatedAt as string,
                ).getTime(),
          };
        });
      },
    );
  };

  createOpenIncidentSelector = () => {
    this.openIncidentSelector = createSelector(
      this.incidentSelector,
      (incidentsWithPlayer: PlayerIncidentList[]) => {
        return incidentsWithPlayer.filter(
          (incident: PlayerIncidentList) => incident.open,
        );
      },
    );
  };

  createClosedIncidentSelector = () => {
    this.closedIncidentSelector = createSelector(
      this.incidentSelector,
      (incidentsWithPlayer: PlayerIncidentList[]) => {
        return incidentsWithPlayer.filter(
          (incident: PlayerIncidentList) => !incident.open,
        );
      },
    );
  };
}
